import React from "react";

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  align = "left",
  className = "",
}) {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}
    >
      {eyebrow && (
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-3">
          {eyebrow}
        </div>
      )}
      <h2 className="font-display text-3xl md:text-5xl leading-[1.05] tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
